import React, { useState } from 'react';
import apiService from '../services/api';

function LandingPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      setLoading(true);
      setError('');
      
      try {
        await apiService.joinWaitlist(email);
        setSubmitted(true);
        setEmail('');
      } catch (err) {
        if (err.message.includes('already on the waitlist')) {
          setError('This email is already on the waitlist');
        } else {
          setError('Something went wrong. Please try again.');
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="App">
      <div className="content">
        <img src={'/icon.png'} alt="echo logo" className="logo" />
        <p className="text">
          all this time, your relationships with others have felt off — pointless communities, one-sided friendships, situationships that stall, performances mistaken for connection — and in a way, your relationship with yourself hasn't been much different. life may have held up a mirror, but you couldn't always see what it was showing you — and maybe you've come to believe it never gave you a sign at all.
        </p>
        <p className="text">
          what you needed was an echo — not a scoreboard to measure you or a stage to perform on, but something that reflects your shifting mind back to you. not noise, but a quiet reminder when you can't hear yourself; a way to feel more certain when you're unsure; a way to calm down when you're scattered; a way to find direction when you're lost. a way to remember.
        </p>
        <p className="text">
          in echo, everything you write — dreams, confessions, fleeting thoughts — shapes a living, changing form — an echo — that moves with you. it traces the map of your mind, uncovers the patterns beneath it, and brings you closer to who you really are and to people whose inner worlds echo your own. no profiles. no likes. just words finding their way to the right people — a place to be seen without being looked at.
        </p>
        
        <div className="email-section">
          {!submitted ? (
            <>
              <form onSubmit={handleSubmit}>
                <input
                  type="email"
                  placeholder="Enter your email for beta access"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="email-input"
                  required
                  disabled={loading}
                />
                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? 'Joining...' : 'Join Beta'}
                </button>
              </form>
              {error && <p className="error-message">{error}</p>}
            </>
          ) : (
            <p className="success-message">Thank you. We'll be in touch.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default LandingPage;